export default function metersToMiles(meters) {
  return (meters * 0.000621371)
}